import { render, staticRenderFns } from "./CustomButtonSave.vue?vue&type=template&id=e97d6790&scoped=true"
import script from "./CustomButtonSave.vue?vue&type=script&lang=js"
export * from "./CustomButtonSave.vue?vue&type=script&lang=js"
import style0 from "./CustomButtonSave.vue?vue&type=style&index=0&id=e97d6790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97d6790",
  null
  
)

export default component.exports